import { defineMessages, type MessageValue } from 'react-intl';

export const giftCardRedemptionMessageMessages = defineMessages<{
  readonly heading: { readonly recipient: MessageValue; readonly sender: MessageValue };
}>({
  heading: {
    defaultMessage: `To {recipient} from {sender}`,
    description: 'Gift Card Redemption Screen | Message | Heading',
  },
});
